import React from 'react';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';

function ChangeIcon({ MobilStatusId }) {
  if (MobilStatusId === 11 || MobilStatusId === 12) {
    return <CancelTwoToneIcon style={{ color: '#FFA500' }} />;
  }

  return <CheckCircleTwoToneIcon style={{ color: '#800080' }} />;
}

export default ChangeIcon;
